import React from 'react';
import './index.less';

export interface IABSUpOrDownTextProps {
  data?: number; 
  compareData?: number | boolean; 
  formatText?: (data: number) => React.ReactNode;
}
 
export interface IABSUpOrDownTextState {
  
}
 
class ABSUpOrDownText extends React.Component<IABSUpOrDownTextProps, IABSUpOrDownTextState> {
  render() { 
    const {data, compareData, formatText} = this.props;
    if (!data && data !== 0) {
      return '--';
    }
    const text = formatText ? formatText(data) : data;
    const compareNum = compareData ? compareData : 0;
    let Dom = text;
    if (data > compareNum) {
      let symbol = '';
      if (compareData === false) {symbol = '+'; }
      Dom = <span className="abs-reits-up-color">{symbol + text}</span>;
    } else if (data < compareNum) {
      Dom = <span className="abs-reits-down-color">{text}</span>;
    }
    return Dom;
  }
}
 
export default ABSUpOrDownText;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUpOrDownText/index.tsx